import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sem-permissao',
  templateUrl: './sem-permissao.component.html',
  styleUrls: ['./sem-permissao.component.css']
})
export class SemPermissaoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
